<template>
    <div class="content-page">
        <div class="bd">
            <div class="tab-header">
                <div class="header-left">
                    <el-button type="primary" size="small" @click="dialogVisible = true; openType = `新增餐厅`">
                        新增餐厅
                    </el-button>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="list">
                <el-table :data="canteenList" style="width: 100%;">
                    <el-table-column label="餐厅名称">
                        <template slot-scope="scope">
                            <div>{{ scope.row.name }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="餐厅经理">
                        <template slot-scope="scope">
                            <div>{{ showManagerName[scope.row.workUserId] || scope.row.workUserId }}</div>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作" header-align="right">
                        <template slot-scope="scope">
                            <div class="float-right">
                                <el-button size="small" type="primary" @click="handleEdit(scope.row)">
                                    编辑
                                </el-button>

                                <el-button size="small" type="danger" @click="handleDelete(scope.row)">
                                    删除
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :page-size="pageSize" :current-page="pageNo" background layout="prev, pager, next, jumper"
                        :total="pageCount">
                    </el-pagination>
                </div>
            </div>
        </div>

        <el-dialog :title="openType" :visible.sync="dialogVisible" :close-on-click-modal="false"
            :close-on-press-escape="false" :append-to-body="true" width="30%">

            <div>
                <el-form ref="form" :model="form" label-width="80px">
                    <el-form-item label="餐厅名称">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>

                    <el-form-item label="餐厅经理">
                        <div class="form-item-container">
                            <el-select v-model="form.workUserId" filterable placeholder="请选择餐厅经理">
                                <el-option v-for="manage in managerList" :label="manage.fullName"
                                    :value="manage.shopWorkerUserId" :key="manage.shopWorkerUserId"></el-option>
                            </el-select>
                        </div>
                    </el-form-item>
                </el-form>
            </div>

            <span slot="footer" class="dialog-footer">
                <el-button @click="handleCancel()">取 消</el-button>
                <el-button type="primary" @click="handleAdd()">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：Api，工具js，第三方插件js，json文件，图片文件等等）
import { findShopWorks, getCanteenList, editCanteen, deleteCanteen, getCanteenListCount, getFloorListCount } from "@/api";
//例如：import 《组件名称》 from '《组件路径》'

export default {
    components: {},
    props: [],
    data() {
        return {
            canteenList: [],
            managerList: [],

            pageNo: 1,
            pageSize: 5,
            pageCount: 10,

            openType: "新增餐厅",
            dialogVisible: false,

            form: {
                name: '',
                restaurantId: '',
                workUserId: '',
            },

            showManagerName: {},
        };
    },
    computed: {},
    watch: {},

    async mounted() {
        await this.getManagerList();
        await this.getData();
    },
    methods: {
        async getData() {
            const tempData = {
                pageNo: this.pageNo,
                row: this.pageSize,
            }
            const result = await getCanteenListCount({}); // 获取记录总数
            this.pageCount = result.data || 1;
            let res = await getCanteenList(tempData); // 获取列表
            this.canteenList = res.data;
        },

        async getManagerList() {
            const res = await findShopWorks({ isAll: 1 });
            this.managerList = res.data;

            this.managerList.forEach(item => {
                this.showManagerName[item.shopWorkerUserId] = item.fullName
            })
        },

        // 新增
        async handleAdd() {
            if (this.form.name == '') {
                this.$message({
                    type: 'error',
                    message: `请输入餐厅名称`
                });

                return
            }
            if (this.form.workUserId == '') {
                this.$message({
                    type: 'error',
                    message: `请选择餐厅经理`
                });

                return
            }

            const res = await editCanteen(this.form);
            if (res.code == 1) {
                this.$message({
                    type: 'success',
                    message: `操作成功`
                });

                this.dialogVisible = false;
                this.form = {
                    name: '',
                    restaurantId: '',
                    workUserId: '',
                }

                // 更新列表
                this.getData()
            } else {
                this.$message({
                    type: 'error',
                    message: `${res.msg}`
                });
            }

        },

        // 编辑
        handleEdit(data) {
            console.log(data);
            this.form.name = data.name;
            this.form.restaurantId = data.restaurantId;
            this.form.workUserId = data.workUserId;

            this.openType = "编辑餐厅";
            this.dialogVisible = true;
        },

        // 删除
        async handleDelete(data) {
            let tips = '确认是否删除?';
            let tipsType = 'none';

            const res = await getFloorListCount({ restaurantId: data.restaurantId });
            if (res.data > 0) {
                tips = '该餐厅已设置楼层，是否继续删除？';
                tipsType = 'warning';
            }

            this.$confirm(tips, '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: tipsType,
            }).then(async () => {

                const tempData = {
                    restaurantId: data.restaurantId
                }
                await deleteCanteen(tempData)

                this.pageNo = Math.ceil((this.pageCount - 1) / this.pageSize);

                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });

                // 更新列表
                this.getData()

            }).catch(() => {
            });
        },

        // 取消
        handleCancel() {
            this.dialogVisible = false;
            this.form = {
                name: '',
                restaurantId: '',
                workUserId: '',
            }
        },

        handleSizeChange() { },

        handleCurrentChange(value) {
            this.pageNo = value;
            this.getData();
        }
    },
};
</script>

<style lang="less" scoped>
.list {
    width: 100%;
    padding: 0 20px;
}

.pagination {
    display: flex;
    justify-content: center;
    align-self: center;
}

.form-item-container {
    width: 100%;
    display: flex;
}

:deep(.el-select) {
    flex: 1;
}

:deep(.el-input-number) {
    flex: 1;
}
</style>